module.exports = __webpack_public_path__ + "img/helpHover.c6b9b2b1.svg";